import { render } from "./kefu.vue?vue&type=template&id=39307ff1&scoped=true"
import script from "./kefu.vue?vue&type=script&lang=js"
export * from "./kefu.vue?vue&type=script&lang=js"

import "./kefu.vue?vue&type=style&index=0&id=39307ff1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39307ff1"]])

export default __exports__